import { useEffect } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import Store, { history } from './redux/store'
import { Provider, useDispatch } from 'react-redux'
import { getDictDataAction } from './modules/dict'
import { ConfigProvider, message, notification } from 'antd'
import Notfound from './pages/notfound'
import zhCN from 'antd/es/locale/zh_CN'
import './assets/css/normalize.css'
import './assets/css/common.scss'
import 'moment/locale/zh-cn'
import Loginpage from './pages/login'
import Express from './pages/expressH5'
import Basiclayout from './pages/basiclayout'
import { ClickToComponent } from 'click-to-react-component'
import './App.less'
// 导入tippy默认样式
import 'tippy.js/dist/tippy.css'
import CustomConfigProviderV5 from './components/CustomConfigProviderV5'
import { AliveScope } from 'react-activation'
import OrderReportH5 from './pages/H5Pages/OrderReportH5'
// 初始化组件：在 Provider 内部调用初始化接口
function AppInitializer() {
  const dispatch = useDispatch()

  useEffect(() => {
    // 项目初始化时获取字典数据
    dispatch(getDictDataAction())
  }, [dispatch])

  return null
}

// 程序主入口 包含全局css、顶层路由配置、全局状态管理、托管路由至redux
function App() {
  useEffect(() => {
    // 配置页面title
    document.title = '咸亨国际供应商协同平台（SCP）'
    // window['console']['log'] =  console.log() //打开默认设置
    // window['console']['log'] = function() {}; //关闭默认设置
  }, [])

  // 设置antd 全局中文、弹出框渲染至父节点
  const config: any = {
    locale: zhCN,
    prefixCls: 'xh',
    space: { size: 10 },
  }
  // 配置message notification
  message.config({ prefixCls: 'xh-message', maxCount: 1 })
  notification.config({
    prefixCls: 'xh-notification',
    getContainer: () => document.body,
  })
  // 设置 Modal、Message、Notification
  ConfigProvider.config({
    prefixCls: 'xh',
  })
  return (
    <Provider store={Store}>
      <AppInitializer />
      <ConnectedRouter history={history}>
        <AliveScope>
          <CustomConfigProviderV5>
            <ConfigProvider
              {...config}
              componentSize="small"
              direction={'ltr'}
              getPopupContainer={(node: any) => {
                if (node) {
                  return node.parentNode
                }
                return document.body
              }}
              input={{ autoComplete: 'off' }}
            >
              <Switch>
                <Route exact path="/login" component={Loginpage} />
                {/* 单独物流页面 */}
                <Route exact path="/expressH5" component={Express} />
                <Route exact path="/orderReportH5" component={OrderReportH5} />
                {/* 定时任务 */}
                {/* <Route path='/rootmanage' component={RootManage} /> */}
                {/* 基础布局 */}
                <Route path="/srm" component={Basiclayout} />
                {/* 默认主页模块 */}
                <Redirect from="/" exact to="/srm/home" />
                <Route path="*" component={Notfound} />
                <Route path="/notFound" component={Notfound} />
                <Redirect to="/notFound" />
              </Switch>
            </ConfigProvider>
          </CustomConfigProviderV5>
        </AliveScope>
      </ConnectedRouter>
      {process.env.REACT_APP_ENABLE_CC === 'true' && (
        <ClickToComponent
          editor={process.env.REACT_APP_CC_EDITOR || 'vscode'}
        />
      )}
    </Provider>
  )
}

export default App
import { useEffect } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import Store, { history } from './redux/store'
import { Provider, useDispatch } from 'react-redux'
import { getDictDataAction } from './modules/dict'
import { ConfigProvider, message, notification } from 'antd'
import Notfound from './pages/notfound'
import zhCN from 'antd/es/locale/zh_CN'
import './assets/css/normalize.css'
import './assets/css/common.scss'
import 'moment/locale/zh-cn'
import Loginpage from './pages/login'
import Express from './pages/expressH5'
import Basiclayout from './pages/basiclayout'
import { ClickToComponent } from 'click-to-react-component'
import './App.less'
// 导入tippy默认样式
import 'tippy.js/dist/tippy.css'
import CustomConfigProviderV5 from './components/CustomConfigProviderV5'
import { AliveScope } from 'react-activation'
import OrderReportH5 from './pages/H5Pages/OrderReportH5'
// 初始化组件：在 Provider 内部调用初始化接口
function AppInitializer() {
  const dispatch = useDispatch()

  useEffect(() => {
    // 项目初始化时获取字典数据
    dispatch(getDictDataAction())
  }, [dispatch])

  return null
}

// 程序主入口 包含全局css、顶层路由配置、全局状态管理、托管路由至redux
function App() {
  useEffect(() => {
    // 配置页面title
    document.title = '咸亨国际供应商协同平台（SCP）'
    // window['console']['log'] =  console.log() //打开默认设置
    // window['console']['log'] = function() {}; //关闭默认设置
  }, [])

  // 设置antd 全局中文、弹出框渲染至父节点
  const config: any = {
    locale: zhCN,
    prefixCls: 'xh',
    space: { size: 10 },
  }
  // 配置message notification
  message.config({ prefixCls: 'xh-message', maxCount: 1 })
  notification.config({
    prefixCls: 'xh-notification',
    getContainer: () => document.body,
  })
  // 设置 Modal、Message、Notification
  ConfigProvider.config({
    prefixCls: 'xh',
  })
  return (
    <Provider store={Store}>
      <AppInitializer />
      <ConnectedRouter history={history}>
        <AliveScope>
          <CustomConfigProviderV5>
            <ConfigProvider
              {...config}
              componentSize="small"
              direction={'ltr'}
              getPopupContainer={(node: any) => {
                if (node) {
                  return node.parentNode
                }
                return document.body
              }}
              input={{ autoComplete: 'off' }}
            >
              <Switch>
                <Route exact path="/login" component={Loginpage} />
                {/* 单独物流页面 */}
                <Route exact path="/expressH5" component={Express} />
                <Route exact path="/orderReportH5" component={OrderReportH5} />
                {/* 定时任务 */}
                {/* <Route path='/rootmanage' component={RootManage} /> */}
                {/* 基础布局 */}
                <Route path="/srm" component={Basiclayout} />
                {/* 默认主页模块 */}
                <Redirect from="/" exact to="/srm/home" />
                <Route path="*" component={Notfound} />
                <Route path="/notFound" component={Notfound} />
                <Redirect to="/notFound" />
              </Switch>
            </ConfigProvider>
          </CustomConfigProviderV5>
        </AliveScope>
      </ConnectedRouter>
      {process.env.REACT_APP_ENABLE_CC === 'true' && (
        <ClickToComponent
          editor={process.env.REACT_APP_CC_EDITOR || 'vscode'}
        />
      )}
    </Provider>
  )
}

export default App
